import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const addEmailRecipient = (alertRuleId: string, email: string) =>
  api.post(`/v1/alert-rules/${alertRuleId}/email-recipients`, { email })

export const useAddEmailRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (email: string) => addEmailRecipient(alertRuleId, email),
    onSuccess: () => {
      queryClient.invalidateQueries([
        'alertRule',
        alertRuleId,
        'emailRecipients',
      ])
      showNotification({
        message: 'Email recipient added successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to add email recipient',
        color: 'red',
      })
    },
  })
}
